import { Role } from './role.model';
import { Customer } from './customer.model';

export class User {
  id?: number;
  name: string;
  email: string;
  password?: string;
  active: boolean;
  createdAt: Date;
  updatedAt: Date;
  lastLogin: Date;
  dailyNotifications: boolean;
  roles?: Role[];
  customers?: Customer[];
  createdBy?: User;

  constructor(object: any) {
    this.id = object.id;
    this.name = object.name;
    this.email = object.email;
    this.password = object.password;
    this.active = object.active;
    this.createdAt = object.createdAt;
    this.updatedAt = object.updatedAt;
    this.lastLogin = object.lastLogin;
    this.dailyNotifications = object.dailyNotifications;
    this.roles = <Role[]>object.roles;
    this.customers = object.customers;
    this.createdBy = object.createdBy;
  }
}



// WEBPACK FOOTER //
// ./src/app/resources/models/user.model.ts